import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
import _find from 'lodash/find';
// Models
import mDeviceLog from 'models/deviceLog';
// Custom
import { openDialog, getDeviceLogsList } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import SubListTemplate from 'components/templates/SubListTemplate';
import LogRow from 'devices/assets/logs/LogRow';
import LogFilters from 'devices/assets/logs/LogFilters';
import { dateFormatter } from 'utils/DateUtils';

class LogsList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDisplayLogInfo = this.handleDisplayLogInfo.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);

    const { type, filter, scope } = _find(
      mDeviceLog.listFeatures.searchFields,
      ['key', 'begin'],
    );

    let previousDayMidnight = new Date();
    previousDayMidnight.setDate(previousDayMidnight.getDate() - 1);
    previousDayMidnight.setHours(0, 0, 0, 0);
    previousDayMidnight = dateFormatter.toServerFormat(previousDayMidnight);

    this.defaultFilters = [
      {
        field: filter.field,
        operator: type.defaultOperator(scope),
        value: previousDayMidnight,
      },
    ];
  }

  // Handlers
  handleDisplayLogInfo(log) {
    const { dispatchOpenDialog } = this.props;
    dispatchOpenDialog({
      actions: [{ type: 'close' }],
      component: {
        type: 'DEVICE_LOG_INFO',
        props: {
          log,
        },
      },
      size: 'xs',
    });
  }

  // Private
  doGetRowComp(props) {
    return <LogRow {...props} onDisplayLogInfo={this.handleDisplayLogInfo} />;
  }

  render() {
    const {
      logs,
      params,
      desynchronized,
      dispatchGetDeviceLogsList,
    } = this.props;
    const { loading } = logs;

    return (
      <SubListTemplate
        title={<LocalizedMessage id="title.logsList" />}
        displayRefresh
        name={mDeviceLog.name}
        listFeatures={mDeviceLog.listFeatures}
        withActions
        nbActions={1}
        elementsData={{
          loading,
          desynchronized,
          elements: logs.elements,
          handleGetList: (pagination, sort, filters) => dispatchGetDeviceLogsList(
            params.id,
            pagination,
            sort,
            filters,
            desynchronized,
          ),
        }}
        defaultFilters={this.defaultFilters}
        withAutoRefresh
        filtersComp={<LogFilters />}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

LogsList.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  logs: fullListShape.isRequired,
  desynchronized: PropTypes.bool.isRequired,
  dispatchOpenDialog: PropTypes.func.isRequired,
  dispatchGetDeviceLogsList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  logs: state.deviceLog.list,
  desynchronized: state.deviceLog.list.desynchronized,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchOpenDialog: (props) => dispatch(openDialog(props)),
  dispatchGetDeviceLogsList: (id, pagination, sort, filters, desynchronized) => dispatch(getDeviceLogsList(id, pagination, sort, filters, desynchronized)),
});

module.exports = connect(mapStateToProps, mapDispatchToProps)(LogsList);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/show/routes/logs/routes/index/components/DeviceLogsList.js